'use client';

import { c as _c } from "react/compiler-runtime";
import { FullscreenExitIcon, FullscreenIcon } from '@/app/[locale]/(worlds)/[roomId]/components/FullscreenIcons';
import ViverseButton from '@/components/ViverseButton';
import { useFullscreenStatus } from '@/hooks/useFullscreenStatus';
import { toggleFullscreen } from '@/lib/fullscreen';
import { cn } from '@/lib/utils';
import { useEffect, useState, type ReactNode } from 'react';
type FullscreenButtonProps = {
  ariaLabel?: string;
  className?: string;
  iconClassName?: string;
  label?: ReactNode;
};
export default function FullscreenButton(t0) {
  const $ = _c(14);
  const {
    ariaLabel,
    className,
    iconClassName,
    label
  } = t0;
  const {
    isFullscreen
  } = useFullscreenStatus();
  const [isFullscreenAvailable, setIsFullscreenAvailable] = useState(false);
  const Icon = isFullscreen ? FullscreenExitIcon : FullscreenIcon;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsFullscreenAvailable(document.fullscreenEnabled && typeof document.documentElement.requestFullscreen === "function");
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  if (!isFullscreenAvailable) {
    return null;
  }
  let t3;
  if ($[2] !== className) {
    t3 = cn("group flex min-w-fit gap-2", className);
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== iconClassName) {
    t4 = cn("[&_path]:fill-vive-primary-20 group-hover:[&_path]:fill-vive-brand-50 size-[18px] transition-colors", iconClassName);
    $[4] = iconClassName;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== Icon || $[7] !== t4) {
    t5 = <Icon className={t4} />;
    $[6] = Icon;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== ariaLabel || $[10] !== label || $[11] !== t3 || $[12] !== t5) {
    t6 = <ViverseButton className={t3} variant="filter" aria-label={ariaLabel} onClick={_temp}>{t5}{label}</ViverseButton>;
    $[9] = ariaLabel;
    $[10] = label;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
function _temp() {
  return toggleFullscreen("standalone-iframe-wrapper");
}